import {
    AnimationBaseController,
    GameApiBase,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameModel } from '../../../../Models/Game/GameModel';

export interface ISettingsScreenButtonControllerOptions {
    onClick: () => void;
    name: string;
}

export class ButtonToggleController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: ISettingsScreenButtonControllerOptions,
        @Inject private _arenaApi: GameApiBase
    ) {
        super('SettingsButtonController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {
                soundOnOff: (value: boolean) => {
                    if (this._options.name === 'button_sound') {
                        this.gotoAndStop(value ? 1 : 0);
                    }
                },
                musicOnOff: (value: boolean) => {
                    if (this._options.name === 'button_music') {
                        this.gotoAndStop(value ? 1 : 0);
                    }
                },
            },
            onTap: () => {
                this._options.onClick();
            },
        };
    }

    protected onInitialize(): void {
        if (this._options.name === 'button_sound') {
            this.gotoAndStop(this.$model.soundOnOff ? 1 : 0);
        } else if (this._options.name === 'button_music') {
            this.gotoAndStop(this.$model.musicOnOff ? 1 : 0);
        } else {
            this.gotoAndStop(0);
        }
    }
}
